module.exports = __webpack_public_path__ + "img/classics32.32bad3e.jpg";